import { render, staticRenderFns } from "./catalogList.vue?vue&type=template&id=e5819e6a"
import script from "./catalogList.vue?vue&type=script&lang=ts"
export * from "./catalogList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports